export const isUTCDate = (dateString: unknown): boolean => {
  if (typeof dateString !== 'string') {
    return false
  }

  const isoUtcRegex = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(\.\d{3})?Z$/

  if (!isoUtcRegex.test(dateString)) {
    return false
  }

  const date = new Date(dateString)
  if (isNaN(date.getTime())) {
    return false
  }

  // reformat date to match the input format (with or without milliseconds)
  const iso = date.toISOString()
  if (dateString.length === 20) {
    // no milliseconds
    return iso.slice(0, 19) + 'Z' === dateString
  }
  return iso === dateString
}
